import {ChargeService} from '@/common/api/charge.service'
import {
    // CHARGE_CREATE,
    // CHARGE_EDIT,
    CHARGE_DELETE,
    CHARGE_GET,
    // CHARGES_GET,
    // CHARGES_BM_GET,
    // CHARGE_ACTIVE,
    // CHARGE_INACTIVE,
    CHARGE_SEARCH,
    // CHARGES_SIMPLE_BM_GET, 
} from './actions/charge.type.js'
import {
    SET_CHARGE,
    SET_CHARGES,
    SET_CHARGE_PAGINATION,
    SET_CHARGE_ACTIVE,
    CHARGE_RESET,
    CHARGE_RESET_STATE,
    //SET_CHARGES_SIMPLE,
} from './mutations/charge.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'

const initialState = () => {
    return {
        charge: {
            id: 0,
            active: false,
            name: "",
            desc: "",
            value: null,
            categoryID: 0,
            categoryName: "",

        },

        chargePagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },

        itemsPerPage: 10,
        charges: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },
        chargesSimple: [],
        categories: [],

    }
}

export const state = initialState()

const getters = {
    charge: state => {
        return state.charge
    },
    charges: state => {
        return state.charges
    },
    chargesSimple: state => {
        return state.chargesSimple
    },
    chargePagination: state => {
        return state.chargePagination
    },
    categories: state => {
        return state.categories
    }
}

export const mutations = {
    [SET_CHARGE](state, data) {
        state.charge = data
    },
    [SET_CHARGES](state, data) {
        state.charges = data
    },
    // [SET_CHARGES_SIMPLE](state, data) {
    //     state.chargesSimple = data
    // },

    // [SET_CATEGORIES](state, data) {
    //     state.categories = data
    // },
    [SET_CHARGE_PAGINATION](state, data) {
        state.charges.activePage = data.page
        state.chargePagination.itemsPerPage = data.itemsPerPage
        state.chargePagination.orderBy = data.orderBy
        state.chargePagination.sortDesc = data.sortDesc
    },
    [SET_CHARGE_ACTIVE](state, active) {
        state.charge.active = active
    },
    [CHARGE_RESET](state) {
        Object.assign(state.charge, initialState().charge)
    },
    [CHARGE_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
}

export const actions = {
    // async [CATEGORIES_GET]({commit}) {
    //     commit(CHANGE_PROGRESS, true)
    //     const {data} = await ServiceService.list_categories()
    //     commit(SET_CATEGORIES, data)
    //     commit(CHANGE_PROGRESS, false)
    // },
    // async [CHARGES_GET]({commit}) {
    //     commit(CHANGE_PROGRESS, true)
    //     const {data} = await ChargeService.list()
    //     commit(SET_CHARGES_SIMPLE, data)
    //     commit(CHANGE_PROGRESS, false)
    // },
    // async [CHARGES_SIMPLE_BM_GET]({commit}, id) {
    //     commit(CHANGE_PROGRESS, true)
    //     const {data} = await ChargeService.listBM(id)
    //     commit(SET_CHARGES_SIMPLE, data)
    //     commit(CHANGE_PROGRESS, false)
    // },
    //
    async [CHARGE_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ChargeService.get(id)
        commit(SET_CHARGE, data)
        commit(CHANGE_PROGRESS, false)
    },
    // async [CHARGES_BM_GET]({commit}, id) {
    //     commit(CHANGE_PROGRESS, true)
    //     const {data} = await ChargeService.bmServices(id)
    //     commit(SET_CHARGES_SIMPLE, data)
    //     commit(CHANGE_PROGRESS, false)
    // },

    async [CHARGE_SEARCH]({commit, state}) {
        // commit(CHANGE_PROGRESS, true)
        const {data} = await ChargeService.search(
            state.charges.activePage,
            state.chargePagination.itemsPerPage,
            state.charges.active,
            state.chargePagination.search,
            state.chargePagination.orderBy,
            state.chargePagination.sortDesc)
        commit(SET_CHARGES, data)
        // commit(CHANGE_PROGRESS, false)
    },
    // [CHARGE_CREATE]({state}) {
    //     return ChargeService.create(state.charge)
    // },
    // [CHARGE_EDIT]({state}) {
    //     return ChargeService.update("", state.charge)
    // },
    // [CHARGE_ACTIVE](_, id) {
    //     return ChargeService.active(id)
    // },
    // [CHARGE_INACTIVE](_, id) {
    //     return ChargeService.inactive(id)
    // },
    [CHARGE_DELETE]({state}) {
        return ChargeService.delete(state.charge.id)
    },
    // [CHARGE_RESET_STATE]({commit}) {
    //     commit(CHARGE_RESET_STATE)
    // }
}
export default {
    state,
    actions,
    mutations,
    getters
}
